import React from 'react';

export default function Icon({ type, className = '' }) {
  switch (type) {
    case 'warning':
      return (
        <svg
          className={className + ' h-4 w-4 fill-orange-600'}
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 64 64"
        >
          <path d="M31.97,64.02C14.33,64-.04,49.6,0,31.97,.04,14.31,14.44-.05,32.06,0c17.63,.05,31.95,14.4,31.94,32.02,0,17.65-14.4,32.03-32.03,32Zm-.02-23.58c1,0,2,0,3.01,0,.92,0,1.05-.14,1.1-1.03,.05-.86,.11-1.72,.18-2.58,.31-4.2,.63-8.4,.94-12.61,.21-2.83,.42-5.66,.65-8.5,.2-2.46-.61-4.48-2.72-5.81-2-1.26-4.12-1.28-6.14-.05-2.13,1.3-2.99,3.3-2.81,5.76,.26,3.39,.53,6.78,.78,10.17,.34,4.6,.67,9.2,1,13.79,.04,.61,.32,.87,.93,.86,1.02-.02,2.05,0,3.08,0Zm.04,4.96c-2.68,0-4.85,2.17-4.85,4.83,0,2.61,2.2,4.81,4.81,4.83,2.68,.02,4.89-2.21,4.87-4.9-.03-2.65-2.17-4.76-4.83-4.76Z" />
        </svg>
      );
    case 'success':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 64 64"
          className={className + ' h-4 w-4 mr-6'}
        >
          <g>
            <path
              fill="#4bba7a"
              d="M.01,34.39v-4.74c.26-.9,.24-1.83,.4-2.74,1.24-7.21,4.42-13.43,9.89-18.31C19.46,.4,30.1-1.98,41.83,1.65c9.14,2.83,15.6,8.93,19.52,17.65,1.67,3.72,2.52,7.65,2.62,11.73-.87-.59-1.55-1.38-2.32-2.08-2.47-2.23-4.87-4.53-7.33-6.76-.36-.33-.64-.82-1.21-.87-.28-.75-.75-1.37-1.33-1.93-.76-.74-1.5-1.5-2.26-2.25-.31-.31-.63-.6-1.02-.82-1.59-.88-3.33-.57-4.77,.85-5.34,5.31-10.69,10.62-16.02,15.95-.35,.35-.54,.4-.91,.02-2.18-2.23-4.38-4.44-6.59-6.65-1.7-1.7-3.93-1.71-5.65-.03-.86,.84-1.72,1.7-2.56,2.56-.27,.28-.53,.59-.73,.93-.9,1.57-.6,3.31,.78,4.71,3.97,4,7.95,8,11.92,12.01,.54,.55,1.09,1.08,1.78,1.45-.04,.31,.24,.42,.4,.58,4.48,4.49,8.97,8.97,13.45,13.45,.22,.22,.48,.41,.55,.74-1.08,.37-2.22,.53-3.34,.73-.85,.15-1.72,.12-2.56,.36h-4.62c-.07-.14-.21-.11-.33-.12-1.39-.11-2.77-.31-4.13-.62C12.03,60.3,2.34,49.89,.34,36.58c-.11-.73-.09-1.48-.33-2.18Z"
            />
            <path
              fill="#32a16c"
              d="M63.97,31.03c.17,3.73-.31,7.39-1.54,10.91-3.71,10.63-11,17.58-21.78,20.87-.16,.05-.33,.06-.49,.09-.08-.33-.33-.52-.55-.74-4.48-4.48-8.97-8.96-13.45-13.45-.16-.16-.44-.27-.4-.58,1.82,.61,3.32,.16,4.62-1.24,1.29-1.39,2.63-2.72,3.97-4.06,5.79-5.77,11.58-11.55,17.4-17.29,1.21-1.2,1.78-2.52,1.36-4.21,.57,.05,.85,.54,1.21,.87,2.46,2.24,4.87,4.53,7.33,6.76,.77,.7,1.45,1.49,2.32,2.08Z"
            />
          </g>
        </svg>
      );
    case 'spinner':
      return (
        <svg
          className={className + ' inline-block animate-spin h-5 w-5 text-gray-400'}
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
        >
          <circle
            className="opacity-25"
            cx="12"
            cy="12"
            r="10"
            stroke="currentColor"
            strokeWidth="4"
          ></circle>
          <path
            className="opacity-75"
            fill="currentColor"
            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
          ></path>
        </svg>
      );

    case 'receipt':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 88.16 102.86"
          className={className + ' h-6 w-6 fill-gray-600'}
        >
          <g id="c">
            <path d="M43.41,83v4h-1.41c-.51-1.28-.9-2.62-1.16-4h2.57Z" />
            <rect x="11.21" y="13.78" width="43.24" height="8" />
            <rect x="11.21" y="30.52" width="43.24" height="8" />
            <rect x="11.21" y="47.27" width="43.24" height="8" />
            <path d="M44.8,64.82c-1.72,2.37-2.99,5.08-3.72,8H11.21v-8H44.8Z" />
            <polygon points="78.22 71.79 60.15 88.12 58.77 86.59 57.51 85.11 50.64 77.01 53.69 74.42 60.48 82.43 75.53 68.82 78.22 71.79" />
            <polygon points="58.77 86.59 57.47 85.15 57.51 85.11 58.77 86.59" />
            <path d="M40.84,83c.26,1.38,.65,2.72,1.16,4h1.41v-4h-2.57Z" />
            <path d="M67,55.31V1H1V87H42c3.41,8.69,11.89,14.86,21.78,14.86,12.89,0,23.38-10.49,23.38-23.39,0-11.8-8.79-21.59-20.16-23.16ZM5,83V5H63V55.1c-7.49,.24-14.1,4.03-18.2,9.72-1.72,2.37-2.99,5.08-3.72,8-.45,1.81-.69,3.7-.69,5.65,0,1.55,.15,3.06,.45,4.53H5Zm58.78,14.86c-10.69,0-19.39-8.7-19.39-19.39,0-1.96,.29-3.86,.84-5.65,.94-3.05,2.61-5.79,4.8-8,3.51-3.54,8.38-5.74,13.75-5.74,10.69,0,19.38,8.7,19.38,19.39s-8.69,19.39-19.38,19.39Z" />
          </g>
        </svg>
      );

    case 'question':
      return (
        <svg
          className={className + ' w-4 h-4 fill-slate-600 cursor-pointer inline-block'}
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 1000 1000"
        >
          <path
            id="path"
            d="M 500 0C 224 0 0 224 0 500C 0 776 224 1000 500 1000C 776 1000 1000 776 1000 500C 1000 224 776 0 500 0C 500 0 500 0 500 0 M 501 191C 626 191 690 275 690 375C 690 475 639 483 595 513C 573 525 558 553 559 575C 559 591 554 602 541 601C 541 601 460 601 460 601C 446 601 436 581 436 570C 436 503 441 488 476 454C 512 421 566 408 567 373C 566 344 549 308 495 306C 463 303 445 314 411 361C 400 373 384 382 372 373C 372 373 318 333 318 333C 309 323 303 307 312 293C 362 218 401 191 501 191C 501 191 501 191 501 191M 500 625C 541 625 575 659 575 700C 576 742 540 776 500 775C 457 775 426 739 425 700C 425 659 459 625 500 625C 500 625 500 625 500 625"
          ></path>
        </svg>
      );
    default:
      return <></>;
  }
}
